import LocationAccordion from './LocationAccordion.vue';

export default {
    data() {
        return {
            open: false,
            showCities: false,
            showEvents: false,
        }
    },

    methods: {
        toggleNavigation() {
            this.open = !this.open;
            EventBus.$emit('ToggleNav');
        },

        toggleCities() {
            this.showEvents = false;
            this.showCities = !this.showCities;
        },

        toggleEvents() {
            this.showCities = false;
            this.showEvents = !this.showEvents;
        }
    },

    components: {
        LocationAccordion
    }
}


// WEBPACK FOOTER //
// ./assets/js/components/MobileNavigation.js